import React from 'react';
import i18n from '../../i18n';
import { Button } from '@mui/material';
import BaseInput from '../../component/form/base-input.component';
import './scss/update-balance.style.scss';
import DialogComponent from '../../component/dialog/dialog.component';
import { formatEUR } from '../../constants/tool.fn';

export default function UpdateBalance({ isOpen, balance, originBalance, onChange, onSave, onClose }: Props) {
    const [isEmpty, setEmpty] = React.useState(false);

    return (
        <DialogComponent
            maxWidth='sm'
            open={isOpen}
            onClose={onClose}
            defaultHeaderProps={{
                title: `${i18n.t('reseller_page_edit_reseller_balance')} ${formatEUR(Number(originBalance || 0))}`,
                onClose: onClose
            }}
        >
            <div className='update-balance'>
                <BaseInput
                    className='code-input'
                    type={'number'}
                    InputLabelProps={{
                        shrink: true
                    }}
                    size={'small'}
                    value={balance}
                    disabled={false}
                    variant='outlined'
                    label={i18n.t('reseller_page_reseller_balance')}
                    onChange={(v) => {
                        onChange(v.target.value)
                    }}
                    fullWidth
                    regularType='price'
                    required
                    isEmpty={isEmpty}
                />
                <div className='btn-group'>
                    <Button
                        className='btn'
                        onClick={() => {
                            setEmpty(true)
                            onSave('ADD')
                        }}>
                        {i18n.t('reseller_page_add')}
                    </Button>
                    <Button
                        className='btn'
                        onClick={() => {
                            setEmpty(true)
                            onSave('DEDUCTION')
                        }}>
                        {i18n.t('reseller_page_deduction')}
                    </Button>
                </div>
            </div>
        </DialogComponent >
    )

}


// ***************
// TYPE
// ***************

type Props = {
    isUpdating: boolean;
    balance: number | string;
    className?: string;
    onChange: (val: string) => void;
    onSave: (type: 'ADD' | 'DEDUCTION') => void;
    onClose: () => void;
    isOpen: boolean;
    originBalance: number;
};